/* eslint-disable no-console */
/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/prefer-single-boolean-return */
import moment from 'moment';
export const validateObject = (validateObj: any) => {
    if (validateObj != undefined && validateObj !==null) {
        return true;
    }
    else {
        return false;
    }
}

export const truncString = (str: any, max: number, add: any) => {
    add = add || '...';
    return (typeof str === 'string' && str.length > max ? str.substring(0, max) + add : str);
};

export const isDateBeforeOrToday = (timestamp: string): boolean => {

    if (!timestamp) {
        console.warn('Timestamp is null or undefined.');
        return false;
    }

    const inputDate = moment(timestamp, 'MM-DD-YYYY', true);
    const today = moment().startOf('day');

    if (!inputDate.isValid()) {
        console.error('Invalid input date:', timestamp);
        return false;
    }

    return inputDate.isSameOrBefore(today, 'day');
};
